import logo from "../../resource/7.png";
import useFormHandler from "../../Hook/useFormHandler";

const AramaPoojaRequest = () => {
  const initialValues = {
    // Personal Information
    first_name: "",
    last_name: "",
    date_of_birth: "",
    gender: "",
    
    // Address Information
    address: "",
    street_address: "",
    street_address_line_2: "",
    city: "",
    postal_code: "",
    country: "",
    
    // Contact Information
    whatsapp_number: "",
    mobile_number: "",
    email_address: "",
    
    // Pooja Purpose
    for_birthday: false,
    for_wedding_anniversary: false,
    for_punyanumoda: false,
    for_other: false,
    other_purpose: "",
    
    // Additional Information
    queries: "",
    
    ip_address: ""
  };

  const validations = {
    // Personal Information
    first_name: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "First Name should contain only letters, spaces, or hyphens",
    },
    last_name: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "Last Name should contain only letters, spaces, or hyphens",
    },
    date_of_birth: {
      required: true,
      pattern: /^\d{4}-\d{2}-\d{2}$/,
      message: "Date of Birth must be in YYYY-MM-DD format",
    },
    gender: {
      required: true,
      validate: (value) =>
        ["male", "female", "other"].includes(value) || "Gender must be Male, Female, or Other",
    },
    
    // Address Information
    address: {
      required: true,
      minLength: 5,
      message: "Address must be at least 5 characters long",
    },
    street_address: {
      required: true,
      minLength: 5,
      message: "Street address must be at least 5 characters long",
    },
    street_address_line_2: {
      required: false,
    },
    city: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "City should contain only letters, spaces, or hyphens",
    },
    postal_code: {
      required: true,
      pattern: /^\d{5,10}$/,
      message: "Postal Code should be 5 to 10 digits",
    },
    country: {
      required: true,
      pattern: /^[A-Za-z\s\-]+$/,
      message: "Country should contain only letters, spaces, or hyphens",
    },
    
    // Contact Information
    whatsapp_number: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "WhatsApp Number should be 10 to 15 digits, with optional '+'",
    },
    mobile_number: {
      required: true,
      pattern: /^\+?\d{10,15}$/,
      message: "Mobile Number should be 10 to 15 digits, with optional '+'",
    },
    email_address: {
      required: true,
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Invalid email format",
    },
    
    // Pooja Purpose - Custom validation to ensure at least one is selected
    for_birthday: {
      required: false,
    },
    
    for_wedding_anniversary: {
      required: false,
    },
    
    for_punyanumoda: {
      required: false,
    },
    
    for_other: {
      required: false,
    },
    
    other_purpose: {
      required: false,
      minLength: 3,
      message: "Please specify the purpose when 'Other' is selected",
    },
    
    // Additional Information
    queries: {
      required: false,
      maxLength: 1000,
      message: "Queries cannot exceed 1000 characters",
    },
  };

  const endpoint = '/create-individual-pooja-requests';

  const transformForApi = (data) => ({
    // Personal Information
    first_name: data.first_name,
    last_name: data.last_name,
    date_of_birth: data.date_of_birth,
    gender: data.gender,
    
    // Address Information
    address: data.address,
    street_address: data.street_address,
    street_address_line_2: data.street_address_line_2,
    city: data.city,
    postal_code: data.postal_code,
    country: data.country,
    
    // Contact Information
    whatsapp_number: data.whatsapp_number,
    mobile_number: data.mobile_number,
    email_address: data.email_address,
    
    // Pooja Purpose
    for_birthday: Boolean(data.for_birthday),
    for_wedding_anniversary: Boolean(data.for_wedding_anniversary),
    for_punyanumoda: Boolean(data.for_punyanumoda),
    for_other: Boolean(data.for_other),
    other_purpose: data.other_purpose,
    
    // Additional Information
    queries: data.queries,
    ip_address: data.ip_address,
  });

  const {
    formData,
    errors,
    loading,
    handleInputChange,
    handleSubmit,
    setFormData,
  } = useFormHandler({
    initialValues,
    validations,
    endpoint,
    includeIP: true,
    transformFn: transformForApi
  });

  return (
    <div className="form-page dark-gold">
      <form onSubmit={handleSubmit}>
        <div className="form-title">
          <img src={logo} alt="Monastery Logo" width={200} />
          <div className="details">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Request Form for Individual Pooja</h2>
          </div>
        </div>

        <p className="font-p mt-5">
          Welcome to the Bhaddheka Vihari Monastery Individual Pooja. Kindly use
          the following form to provide your details.
        </p>
        
        <p className="font-p mt-5">Full Name*</p>
        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="text"
              id="first_name"
              name="first_name"
              value={formData.first_name}
              onChange={handleInputChange}
            />
            <label htmlFor="first_name">First Name</label>
            {errors.first_name && <span className="error">{errors.first_name}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="last_name"
              name="last_name"
              value={formData.last_name}
              onChange={handleInputChange}
            />
            <label htmlFor="last_name">Last Name</label>
            {errors.last_name && <span className="error">{errors.last_name}</span>}
          </div>
        </div>

        <div className="form-box mt-4">
          <div className="form-item">
            <input
              type="date"
              id="date_of_birth"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleInputChange}
            />
            <label htmlFor="date_of_birth">Date of Birth*</label>
            {errors.date_of_birth && <span className="error">{errors.date_of_birth}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Gender*</p>
        <div className="gender-box">
          <div>
            <input
              type="radio"
              id="male"
              name="gender"
              value="male"
              checked={formData.gender === "male"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="male">Male</label>
          </div>
          <div>
            <input
              type="radio"
              id="female"
              name="gender"
              value="female"
              checked={formData.gender === "female"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="female">Female</label>
          </div>
          <div>
            <input
              type="radio"
              id="other"
              name="gender"
              value="other"
              checked={formData.gender === "other"}
              onChange={handleInputChange}
              className="mt-5"
            />
            <label htmlFor="other">Other</label>
          </div>
        </div>
        {errors.gender && <span className="error">{errors.gender}</span>}

        <p className="font-p mt-5">Address*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
            <label htmlFor="address">Full Address</label>
            {errors.address && <span className="error">{errors.address}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Street Address*</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="street_address"
              name="street_address"
              value={formData.street_address}
              onChange={handleInputChange}
            />
            <label htmlFor="street_address">Street Address</label>
            {errors.street_address && <span className="error">{errors.street_address}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Street Address Line 2</p>
        <div className="form-box1 mt-4">
          <div className="form-item">
            <input
              type="text"
              id="street_address_line_2"
              name="street_address_line_2"
              value={formData.street_address_line_2}
              onChange={handleInputChange}
            />
            <label htmlFor="street_address_line_2">Apartment, Unit, etc. (Optional)</label>
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
            />
            <label htmlFor="city">City*</label>
            {errors.city && <span className="error">{errors.city}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="postal_code"
              name="postal_code"
              value={formData.postal_code}
              onChange={handleInputChange}
            />
            <label htmlFor="postal_code">Postal Code*</label>
            {errors.postal_code && <span className="error">{errors.postal_code}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="text"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
            />
            <label htmlFor="country">Country*</label>
            {errors.country && <span className="error">{errors.country}</span>}
          </div>
        </div>

        <div className="form-box mt-5">
          <div className="form-item">
            <input
              type="text"
              id="whatsapp_number"
              name="whatsapp_number"
              value={formData.whatsapp_number}
              onChange={handleInputChange}
            />
            <label htmlFor="whatsapp_number">WhatsApp Number*</label>
            {errors.whatsapp_number && <span className="error">{errors.whatsapp_number}</span>}
          </div>
          <div className="form-item">
            <input
              type="text"
              id="mobile_number"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleInputChange}
            />
            <label htmlFor="mobile_number">Mobile Phone Number* (including country code)</label>
            {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
          </div>
        </div>

        <div className="form-box1 mt-5">
          <div className="form-item">
            <input
              type="email"
              id="email_address"
              name="email_address"
              value={formData.email_address}
              onChange={handleInputChange}
            />
            <label htmlFor="email_address">Email Address*</label>
            {errors.email_address && <span className="error">{errors.email_address}</span>}
          </div>
        </div>

        <p className="font-p mt-5">Please indicate the purpose of the Individual Pooja* (Select all that apply)</p>
        <div className="selection mt-5">
          <div className="checkbox-box">
            <label htmlFor="for_birthday">Birthday</label>
            <input
              type="checkbox"
              id="for_birthday"
              name="for_birthday"
              className="checkbox"
              checked={formData.for_birthday}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="for_wedding_anniversary">Wedding Anniversary</label>
            <input
              type="checkbox"
              id="for_wedding_anniversary"
              name="for_wedding_anniversary"
              className="checkbox"
              checked={formData.for_wedding_anniversary}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="for_punyanumoda">Punyanumoda (Deceased)</label>
            <input
              type="checkbox"
              id="for_punyanumoda"
              name="for_punyanumoda"
              className="checkbox"
              checked={formData.for_punyanumoda}
              onChange={handleInputChange}
            />
          </div>
          <div className="checkbox-box">
            <label htmlFor="for_other">Other</label>
            <input
              type="checkbox"
              id="for_other"
              name="for_other"
              className="checkbox"
              checked={formData.for_other}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {errors.for_birthday && <span className="error">{errors.for_birthday}</span>}

        {formData.for_other && (
          <div className="form-box1 mt-4">
            <div className="form-item">
              <input
                type="text"
                id="other_purpose"
                name="other_purpose"
                value={formData.other_purpose}
                onChange={handleInputChange}
              />
              <label htmlFor="other_purpose">Please specify other purpose</label>
              {errors.other_purpose && <span className="error">{errors.other_purpose}</span>}
            </div>
          </div>
        )}

        <p className="font-p mt-5">
          Please write any queries you may have regarding the Individual Arama
          Pooja Project.
        </p>

        <div className="form-item mt-4">
          <textarea
            id="queries"
            name="queries"
            value={formData.queries}
            onChange={handleInputChange}
            rows="6"
            placeholder="Optional - write any questions or queries about the Individual Arama Pooja..."
          />
          {errors.queries && <span className="error">{errors.queries}</span>}
        </div>

        <button
          type="submit"
          id="submitbtn"
          className="mt-5"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <p className="font-p mt-4">We will be in touch with you shortly.</p>

        <p className="font-p mt-4">
          We sincerely appreciate your generosity and thank you for being an
          integral part of the Arama Pooja. Your participation is valued and
          deeply appreciated.
        </p>

        <p className="font-p mt-4">
          We are truly grateful for your involvement in the Arama Pooja
          community at the Bhaddheka Vihara Monastery.
        </p>
      </form>
    </div>
  );
};

export default AramaPoojaRequest;